<template>
  <kendo-window
    ref="addUserToVehicleDialog"
    :width="'700px'"
    :modal="true"
    title="Assign Vehicles"
    style="display: none"
    v-on:close="onClose"
  >
    <div class="row">
      <div class="input-group ml-3 mb-3 w-50">
        <input
          type="text"
          v-model="searchText"
          class="form-control"
          placeholder="Search"
          aria-label="Search"
          aria-describedby="basic-addon2"
          @input="search"
        />
        <div class="input-group-append">
          <button class="btn btn-primary">search</button>
        </div>
      </div>
    </div>
    <Grid
      ref="grid"
      :style="{ height: '500px' }"
      :data-items="items"
      :selected-field="selectedField"
      :columns="columns"
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange"
      @rowclick="onRowClick"
    >
    </Grid>
    <button class="btn btn-primary" @click="addUsers">
      <!-- Add ({{ checkedVehicles.length }}) Vehicles -->
      Add Users
    </button>
  </kendo-window>
</template>
<script>
// import { notifyWarn } from "@/utils/notification-helper";
export default {
  props: ["users"],
  data: function () {
    return {
      filteredUserList: [],
      vehicleInfo: null,
      selectedField: "selected",
      selectedId: null,
      searchText: "",
      usersList: [],
    };
  },
  computed: {
    areAllSelected() {
      return (
        this.filteredUserList.findIndex((item) => item.selected === false) ===
        -1
      );
    },
    columns() {
      return [
        {
          field: "selected",
          width: "50px",
          headerSelectionValue: this.areAllSelected,
        },
        { field: "name", title: "name" },
        { field: "mobileNo", title: "Mobile No" },
      ];
    },
    items() {
      return this.filteredUserList;
    },
  }, // Computed
  methods: {
    search(event) {
      const text = event.target.value.toLowerCase();
      this.filteredUserList = this.usersList.filter((user) =>
        (user.name + "" + user.mobileNo).toLowerCase().includes(text)
      );
    },
    addUsers() {
      const users = this.usersList.filter((user) => user.selected);
      this.$emit('addUsersToVehicle', { vehicleInfo: this.vehicleInfo, users: users });
      this.close();
    },
    onHeaderSelectionChange(event) {
      this.filteredUserList.map(
        (item) => (item.selected = event.event.target.checked)
      );
    },
    onSelectionChange(event) {
      this.checkUncheckUsers(event);
    },
    onRowClick(event) {
      this.selectedId = event.dataItem.id;
      this.checkUncheckUsers(event);
    },
    checkUncheckUsers(event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
      console.log("selected ", event.dataItem[this.selectedField]);
    },
    open(vehicleInfo) {
      this.vehicleInfo = vehicleInfo.dataItem;
      const userIds = this.vehicleInfo.users.map((user) => user.userId);
      if (userIds.length) {
        this.usersList.forEach((user) => {
          if(userIds.includes(user.id)) user.selected = true;
        });
      }
      this.$refs.addUserToVehicleDialog.kendoWidget().center().open();
    },
    close() {
      this.$refs.addUserToVehicleDialog.kendoWidget().close();
      this.clearFields();
    },
    onClose() {
      this.clearFields();
    },
    clearFields() {
      this.usersList.forEach((v) => (v.selected = false));
      this.filteredUserList = this.usersList;
      this.userInfo = null;
      this.searchText = "";
    },
    init(users) {
      this.usersList = users.map((user) => ({ ...user, selected: false}));
      this.filteredUserList = this.usersList;
    }
  }, // methods
  watch: {
    users(newValue) {
      if (newValue.length > 0) {
        this.init(newValue);
      }
    },
  }, // Watch
  mounted() {
    this.init(this.users);
  },
};
</script>

<style scoped>
.toggle_mobile_web{
  width: 700px;
}
@media only screen and (max-width: 768px) {
  .toggle_mobile_web{
     width: 100% !important;
  } 
}
</style>